import { render } from "./SingleSelect.vue?vue&type=template&id=3c128e7e&scoped=true&ts=true"
import script from "./SingleSelect.vue?vue&type=script&lang=ts"
export * from "./SingleSelect.vue?vue&type=script&lang=ts"

import "./SingleSelect.vue?vue&type=style&index=0&id=3c128e7e&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c128e7e"]])

export default __exports__